import { initialer } from "./sakerUtils";

export const Avatar = ({ person, size = 24, className = "" }) => {
  if (!person) return null;
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full text-white font-semibold shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(9, Math.round(size * 0.38)),
        background: person.color || "#8B5CF6",
      }}
      title={person.name}
      data-testid={`avatar-${person.id}`}
    >
      {initialer(person.name)}
    </span>
  );
};
